var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatOnSuitcases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cat On Suitcases") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 60,
    fill: "#edf0f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6,83.6a60,60,0,0,0,116.8,0Z",
    fill: "#e6ebed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4,91.8a4.8,4.8,0,0,0,4.9,4.8h77.4a4.8,4.8,0,0,0,4.9-4.8V81.3H26.4Z",
    fill: "#3c5b6c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.7,65.9H31.3a4.9,4.9,0,0,0-4.9,4.9V81.3h87.2V70.8A4.9,4.9,0,0,0,108.7,65.9Z",
    fill: "#8297a1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6,63.2c0,1.5,1.5,2.7,3.3,2.7H96.1c1.8,0,3.3-1.2,3.3-2.7V57.5H40.6Z",
    fill: "#53717f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1,49.1H43.9c-1.8,0-3.3,1.2-3.3,2.6v5.8H99.4V51.7C99.4,50.3,97.9,49.1,96.1,49.1Z",
    fill: "#8297a1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4,44.8l-.5-4.1c0-.1.1-.2.2-.1L54,43.1c.1.1.1.2,0,.2l-2.5,1.6A.1.1,0,0,1,51.4,44.8Z",
    fill: "#244759"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2,44.8l.5-4.1c0-.1-.1-.2-.2-.1l-3,2.5c0,.1,0,.2.1.2L61,44.9C61.1,44.9,61.2,44.9,61.2,44.8Z",
    fill: "#244759"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.1,
    y: 65.5,
    width: 5.2,
    height: 31.63,
    rx: 0.7,
    fill: "#b3bfc6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96.6,
    y: 65.5,
    width: 5.2,
    height: 31.63,
    rx: 0.7,
    fill: "#b3bfc6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2,
    y: 54.7,
    width: 15.5,
    height: 5.72,
    fill: "#b3bfc6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6,86.4H66.4a2.9,2.9,0,0,1-3-3V81.2h1.9v2.2a1.1,1.1,0,0,0,1.1,1.1h8.2a1.1,1.1,0,0,0,1.1-1.1V81.2h1.9v2.2A2.9,2.9,0,0,1,74.6,86.4Z",
    fill: "#8297a1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2,47.1c0-.1-.1-.8-.2-1.4h0C87,42,82.4,39,76.7,39a14.2,14.2,0,0,0-6.8,1.7A37.6,37.6,0,0,0,62,45.6a6.9,6.9,0,0,0-5.7-2.8c-3.8,0-6.8,2.7-6.8,6.1v.2H67.8c1.8,1.9,5.1,3.2,8.9,3.2s6.9-1.2,8.7-3c.4,4.2.6,9.6-.5,11.8-1.7,3.8-6,4.8-6,4.9a.9.9,0,0,0-.7,1.1,1,1,0,0,0,.9.7h.2a11.3,11.3,0,0,0,7.4-5.9C88.4,58.2,87.6,50.5,87.2,47.1Z",
    fill: "#3c5b6c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6,33.5H87.9c-.2,0-.5-.2-.5-.4a.6.6,0,0,1,.1-.7L93,27.5H88a.6.6,0,0,1,0-1.2h6.6a.7.7,0,0,1,.6.4.7.7,0,0,1-.2.7l-5.5,4.9h5.1a.6.6,0,0,1,0,1.2Z",
    fill: "#fbd149"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.8,22.8H99a.7.7,0,0,1-.6-.4.7.7,0,0,1,.2-.7l3.7-3.2H99.1a.6.6,0,1,1,0-1.2h4.7a.5.5,0,0,1,.6.4.5.5,0,0,1-.2.6l-3.6,3.3h3.2a.6.6,0,1,1,0,1.2Z",
    fill: "#fbd149"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4,15.6H92.6a.6.6,0,0,1-.6-.3.6.6,0,0,1,.2-.7l1.6-1.5H92.6a.6.6,0,0,1-.6-.6.6.6,0,0,1,.6-.6h2.8c.2,0,.5.2.5.4a.6.6,0,0,1-.1.7l-1.7,1.4h1.3a.6.6,0,0,1,.6.6A.6.6,0,0,1,95.4,15.6Z",
    fill: "#fbd149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatOnSuitcases);
export default __webpack_public_path__ + "static/media/cat-on-suitcases.2431fab8.svg";
export { ForwardRef as ReactComponent };